import React, { useState } from 'react';

import { Tooltip } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { COLOR_PRIMARY_1 } from 'src/utils/colors';
import { Chip, ClickAwayListener } from '@mui/material';

const FilterChip = ({
  label,
  value,
  variant,
  handleOnClick,
  styles,
  tooltipText,
}: {
  variant: 'filled' | 'outlined';
  label: string | number | JSX.Element;
  value: string | number | (number | 'all')[];
  handleOnClick: (value: string | number | (number | 'all')[]) => void;
  styles?: any;
  tooltipText?: string;
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));

  const chipComponent = (
    <Chip
      label={label}
      variant={variant}
      onClick={() => {
        handleOnClick(value);
        setOpen(true);
      }}
      sx={{
        minWidth: 50,
        marginTop: '10px',
        marginRight: '5px',
        borderColor: COLOR_PRIMARY_1,
        borderWidth: '1px',
        color: COLOR_PRIMARY_1,
        fontWeight: 500,
        '&.MuiChip-filled': {
          backgroundColor: COLOR_PRIMARY_1,
          color: '#fff',
        },
        ...styles,
      }}
    />
  );

  if (!tooltipText) {
    return chipComponent;
  }

  if (isMobileDevice) {
    return (
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div>
          <Tooltip title={tooltipText} open={open}>
            {chipComponent}
          </Tooltip>
        </div>
      </ClickAwayListener>
    );
  }

  return <Tooltip title={tooltipText}>{chipComponent}</Tooltip>;
};

export default FilterChip;
